module.exports = __webpack_public_path__ + "img/ignitionOn.cb590205.svg";